module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.4318c827.webp";